import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ce69212"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "imgs" }

import { ImagePreview } from 'vant'
// 预览图片
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: ['imglist', 'imgWidth', 'imgHeight'],
  setup(__props) {

const props = __props


const img = ref(props.imglist.split(','))

const getImg = (list, index) => {
  ImagePreview({ images: list, showIndex: true, loop: false, startPosition: index })
}

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(img.value, (item, index) => {
      return (_openBlock(), _createBlock(_component_van_image, {
        width: __props.imgWidth,
        height: __props.imgHeight,
        onClick: ($event: any) => (getImg(img.value, index)),
        fit: "cover",
        key: index,
        src: item,
        radius: "5",
        alt: "",
        srcset: ""
      }, null, 8, ["width", "height", "onClick", "src"]))
    }), 128))
  ]))
}
}

})